import { render, staticRenderFns } from "./supplierStockOrderDetails.vue?vue&type=template&id=5693ea48&scoped=true"
import script from "./supplierStockOrderDetails.vue?vue&type=script&lang=js"
export * from "./supplierStockOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./supplierStockOrderDetails.vue?vue&type=style&index=0&id=5693ea48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5693ea48",
  null
  
)

export default component.exports